import zhCN from '../../.octopus/zh-CN/index.js';

export default {
  TntdNewReference: zhCN,
};
